import { render } from "./Deducation.vue?vue&type=template&id=3f52d960"
import script from "./Deducation.vue?vue&type=script&lang=js"
export * from "./Deducation.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__